"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableActionBar = exports.DropdownCta = exports.ButtonCta = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = require("../../utils/classify");
var _qa = require("../../utils/qa");
var _Button = require("../Button");
var _ButtonDropdown = require("../ButtonDropdown");
var _TableBarModule = _interopRequireDefault(require("./TableBar.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ButtonCta = _ref => {
  let {
    classNames,
    testId,
    ...props
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
    ...props,
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'button-cta'
    }),
    type: "primary",
    size: "small",
    classNames: {
      ...classNames,
      wrapper: _TableBarModule.default.buttonCta
    }
  });
};
exports.ButtonCta = ButtonCta;
const DropdownCta = _ref2 => {
  let {
    classNames,
    testId,
    ...props
  } = _ref2;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonDropdown.SimpleButtonDropdown, {
    ...props,
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'dropdown-cta'
    }),
    type: "primary",
    size: "small",
    classNames: {
      ...classNames,
      buttonWrapper: _TableBarModule.default.buttonCta
    }
  });
};
exports.DropdownCta = DropdownCta;
const TableActionBar = _ref3 => {
  let {
    children,
    className,
    testId,
    ...props
  } = _ref3;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    ...props,
    className: (0, _classify.classify)(_TableBarModule.default.tableActionBar, className),
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'action-bar'
    }),
    children: children
  });
};
exports.TableActionBar = TableActionBar;